"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _GroupJoin = _interopRequireDefault(require("../groups-destination/GroupJoin"));

var cssAnchorName = 'site-wide';
exports.cssAnchorName = cssAnchorName;

var SiteWideComponents = function SiteWideComponents() {
  return (0, _preact.h)("div", null, (0, _preact.h)(_GroupJoin.default, null));
};

var _default = SiteWideComponents;
exports.default = _default;